import advancedSearch from './advanced-search'
import partyEdit from './party-edit'

export default [
  {
    path: '/',
    redirect: { name: 'dashboard' },
    meta: { requiresAuth: true },
    component: _ => import('@/views/Dashboard'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { requiresAuth: true },
    component: _ => import('@/views/Dashboard'),
  },
  {
    path: '/import-party',
    name: 'import-party',
    meta: {
      requiresAuth: true,
      title: 'Import Party - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/ImportParty'),
  },
  {
    path: '/logs',
    name: 'logs',
    meta: {
      requiresAuth: true,
      title: 'Logs - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/Logs'),
  },
  {
    path: '/merge-party',
    name: 'merge-party',
    meta: {
      requiresAuth: true,
      title: 'Merge Party - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/MergeParty'),
  },
  {
    path: '/party-surveys',
    name: 'party-surveys',
    meta: {
      requiresAuth: true,
      title: 'Party Surveys - Innovation Law Lab Platform',
    },
    component: _ => import('@/views/PartySurveys'),
  },
  {
    path: '/notifications',
    name: 'notifications',
    meta: { requiresAuth: true },
    component: _ => import('@/views/Notifications'),
  },
  {
    path: '/notifications/:notificationId',
    name: 'goToNotification',
    meta: { requiresAuth: true },
    component: _ => import('@/views/Notifications'),
  },
  {
    path: '/party/create',
    name: 'partyCreate',
    meta: { requiresAuth: true },
    component: _ => import('@/views/PartyCreate'),
  },
  {
    path: '/party/create/record/:recordId/case/:caseId',
    name: 'partyCreateInCase',
    meta: { requiresAuth: true },
    props: true,
    component: _ => import('@/views/PartyCreate'),
  },
  {
    path: '/party/:id',
    name: 'partyDisplay',
    meta: { requiresAuth: true },
    redirect: { name: 'pe-personal-details' },
  },
  partyEdit,
  {
    path: '/record/:id',
    name: 'record',
    meta: {
      requiresAuth: true,
      tmetric: { enabled: true },
    },
    component: _ => import('@/views/Record'),
  },
  {
    path: '/record/:id/case/:caseId',
    name: 'case',
    meta: {
      requiresAuth: true,
      tmetric: { enabled: true },
    },
    component: _ => import('@/views/Case'),
  },
  advancedSearch,
  {
    path: '/search',
    name: 'fastSearch',
    meta: { requiresAuth: true },
    component: _ => import('@/views/FastSearch'),
  },
]
